type TransformIndividualFirmChangeDataType = {
  ISIN: string;
  PPE: number;
  BQ: number;
  WHTP: number;
  E: number;
  ID: number;
  SPPE: number;
  FSV: number;
  MAV: number;
};

function transformIndividualFirm(data: TransformIndividualFirmChangeDataType) {
  const {
    ISIN: isin,
    PPE: buyIndividualVolume,
    BQ: buyIndividualCount,
    WHTP: buyFirmVolume,
    E: buyFirmCount,
    ID: selIndividualVolume,
    SPPE: selIndividualCount,
    FSV: selFirmVolume,
    MAV: selFirmCount,
  } = data;

  return {
    isin,
    buyIndividualVolume,
    buyIndividualCount,
    buyFirmVolume,
    buyFirmCount,
    selIndividualVolume,
    selIndividualCount,
    selFirmVolume,
    selFirmCount,
  };
}

export { transformIndividualFirm };
